import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  Radio
} from 'semantic-ui-react'
import {
  DateTextBox,
  TimeFreeTextBox24
} from 'react-lib/apps/common'

const CardReAssessmentUrinaryUX = (props: any) => {
    return(
      <div
        style={{position: "relative", padding: "1rem", marginTop: "1rem"}}>
        <Form>
          <FormGroup
            style={{ display: "flex", alignItems: "center" }}>
            <label
              style={{width: "40rem", whiteSpace: "normal"}}>
              {props.languageUX === "en" ? "1. Hand Washing: Wash your hands in 7 steps according to the 5 Moment principle." : "1. Hand Washing ล้างมือ 7 ขั้นตอน ตามหลักการ 5 Moment"}
            </label>
            <div
              style={{display: "flex", gap: "2rem", padding: "0rem 0rem 0rem 2rem"}}>
              
              <Radio
                checked={props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestOne === "Yes"}
                label="Yes"
                name="urinaryQuestion.urinaryQuestOne"
                onChange={props.onChangeData}
                value="Yes">
              </Radio>
              <Radio
                checked={props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestOne === "No"}
                label="No"
                name="urinaryQuestion.urinaryQuestOne"
                onChange={props.onChangeData}
                value="No">
              </Radio>
              <Radio
                checked={props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestOne === "NA"}
                label="NA"
                name="urinaryQuestion.urinaryQuestOne"
                onChange={props.onChangeData}
                value="NA">
              </Radio>
            </div>
          </FormGroup>
          <FormGroup
            style={{ display: "flex", alignItems: "center" }}>
            <label
              style={{width: "40rem", whiteSpace: "normal"}}>
              {props.languageUX === "en" ? "2. Avoid unnecessary urinary catheters. Urinary catheters should be used only when necessary and indicated." : "2. Avoid unnecessary urinary catheters สวนปัสสาวะเมื่อมีความจำเป็นและมีข้อบ่งชี้เท่านั้น"}
            </label>
            <div
              style={{display: "flex", gap: "2rem", padding: "0rem 0rem 0rem 2rem"}}>
              
              <Radio
                checked={props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestTwo === "Yes"}
                label="Yes"
                name="urinaryQuestion.urinaryQuestTwo"
                onChange={props.onChangeData}
                value="Yes">
              </Radio>
              <Radio
                checked={props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestTwo === "No"}
                label="No"
                name="urinaryQuestion.urinaryQuestTwo"
                onChange={props.onChangeData}
                value="No">
              </Radio>
              <Radio
                checked={props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestTwo === "NA"}
                label="NA"
                name="urinaryQuestion.urinaryQuestTwo"
                onChange={props.onChangeData}
                value="NA">
              </Radio>
            </div>
          </FormGroup>
          <FormGroup
            style={{ display: "flex", alignItems: "center" }}>
            <label
              style={{width: "40rem", whiteSpace: "normal"}}>
              {props.languageUX === "en" ? "3. Review urinary catheter necessity daily. The nurse asks the doctor about the necessity of indwelling a urinary catheter every morning." : "3. Review urinary catheter necessity daily พยาบาลสอบถามความจำเป็นการคาสายสวนปัสสาวะ กับแพทย์ทุกเช้า"}
            </label>
            <div
              style={{display: "flex", gap: "2rem", padding: "0rem 0rem 0rem 2rem"}}>
              
              <Radio
                checked={props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestThree === "Yes"}
                label="Yes"
                name="urinaryQuestion.urinaryQuestThree"
                onChange={props.onChangeData}
                value="Yes">
              </Radio>
              <Radio
                checked={props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestThree === "No"}
                label="No"
                name="urinaryQuestion.urinaryQuestThree"
                onChange={props.onChangeData}
                value="No">
              </Radio>
              <Radio
                checked={props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestThree === "NA"}
                label="NA"
                name="urinaryQuestion.urinaryQuestThree"
                onChange={props.onChangeData}
                value="NA">
              </Radio>
            </div>
          </FormGroup>
          <FormGroup
            style={{ display: "flex", alignItems: "center" }}>
            <label
              style={{width: "40rem", whiteSpace: "normal"}}>
              {props.languageUX === "en" ? "4. Maintain urinary catheter based on recommended guideline" : "4. ดูแลรักษาสายสวนปัสสาวะตามคำแนะนำ"}
            </label>
            <div
              style={{display: "flex", gap: "2rem", padding: "0rem 0rem 0rem 2rem"}}>
              
              <Radio
                checked={props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFour === "Yes"}
                label="Yes"
                name="urinaryQuestion.urinaryQuestFour"
                onChange={props.onChangeData}
                value="Yes">
              </Radio>
              <Radio
                checked={props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFour === "No"}
                label="No"
                name="urinaryQuestion.urinaryQuestFour"
                onChange={props.onChangeData}
                value="No">
              </Radio>
              <Radio
                checked={props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFour === "NA"}
                label="NA"
                name="urinaryQuestion.urinaryQuestFour"
                onChange={props.onChangeData}
                value="NA">
              </Radio>
            </div>
          </FormGroup>
        </Form>
        <Form>
          <FormGroup
            style={{ display: "flex", alignItems: "center", marginLeft: "1rem" }}>
            <label
              style={{width: "38.5rem", whiteSpace: "normal"}}>
              {props.languageUX === "en" ? "4.1 Closed drainage system" : "4.1 ระบบระบายน้ำแบบปิด"}
            </label>
            <div
              style={{display: "flex", gap: "2rem", padding: "0rem 0rem 0rem 2rem"}}>
              
              <Radio
                checked={props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubOne === "Yes"}
                label="Yes"
                name="urinaryQuestion.urinaryQuestFourSubOne"
                onChange={props.onChangeData}
                value="Yes">
              </Radio>
              <Radio
                checked={props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubOne === "No"}
                label="No"
                name="urinaryQuestion.urinaryQuestFourSubOne"
                onChange={props.onChangeData}
                value="No">
              </Radio>
              <Radio
                checked={props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubOne === "NA"}
                label="NA"
                name="urinaryQuestion.urinaryQuestFourSubOne"
                onChange={props.onChangeData}
                value="NA">
              </Radio>
            </div>
          </FormGroup>
          <FormGroup
            style={{ display: "flex", alignItems: "center", marginLeft: "1rem" }}>
            <label
              style={{width: "38.5rem", whiteSpace: "normal"}}>
              {props.languageUX === "en" ? "4.2 Fixed catheter" : "4.2 สายสวนปัสสาวะแบบติดแน่น"}
            </label>
            <div
              style={{display: "flex", gap: "2rem", padding: "0rem 0rem 0rem 2rem"}}>
              
              <Radio
                checked={props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubTwo === "Yes"}
                label="Yes"
                name="urinaryQuestion.urinaryQuestFourSubTwo"
                onChange={props.onChangeData}
                value="Yes">
              </Radio>
              <Radio
                checked={props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubTwo === "No"}
                label="No"
                name="urinaryQuestion.urinaryQuestFourSubTwo"
                onChange={props.onChangeData}
                value="No">
              </Radio>
              <Radio
                checked={props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubTwo === "NA"}
                label="NA"
                name="urinaryQuestion.urinaryQuestFourSubTwo"
                onChange={props.onChangeData}
                value="NA">
              </Radio>
            </div>
          </FormGroup>
          <FormGroup
            style={{ display: "flex", alignItems: "center", marginLeft: "1rem" }}>
            <label
              style={{width: "38.5rem", whiteSpace: "normal"}}>
              {props.languageUX === "en" ? "4.3 Urine bag hang below bladder" : "4.3 ถุงปัสสาวะห้อยอยู่ใต้กระเพาะปัสสาวะ"}
            </label>
            <div
              style={{display: "flex", gap: "2rem", padding: "0rem 0rem 0rem 2rem"}}>
              
              <Radio
                checked={props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubThree === "Yes"}
                label="Yes"
                name="urinaryQuestion.urinaryQuestFourSubThree"
                onChange={props.onChangeData}
                value="Yes">
              </Radio>
              <Radio
                checked={props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubThree === "No"}
                label="No"
                name="urinaryQuestion.urinaryQuestFourSubThree"
                onChange={props.onChangeData}
                value="No">
              </Radio>
              <Radio
                checked={props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubThree === "NA"}
                label="NA"
                name="urinaryQuestion.urinaryQuestFourSubThree"
                onChange={props.onChangeData}
                value="NA">
              </Radio>
            </div>
          </FormGroup>
          <FormGroup
            style={{ display: "flex", alignItems: "center", marginLeft: "1rem" }}>
            <label
              style={{width: "38.5rem", whiteSpace: "normal"}}>
              {props.languageUX === "en" ? "4.4 Aseptic technique" : "4.4 เทคนิคปลอดเชื้อ"}
            </label>
            <div
              style={{display: "flex", gap: "2rem", padding: "0rem 0rem 0rem 2rem"}}>
              
              <Radio
                checked={props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubFour === "Yes"}
                label="Yes"
                name="urinaryQuestion.urinaryQuestFourSubFour"
                onChange={props.onChangeData}
                value="Yes">
              </Radio>
              <Radio
                checked={props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubFour === "No"}
                label="No"
                name="urinaryQuestion.urinaryQuestFourSubFour"
                onChange={props.onChangeData}
                value="No">
              </Radio>
              <Radio
                checked={props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubFour === "NA"}
                label="NA"
                name="urinaryQuestion.urinaryQuestFourSubFour"
                onChange={props.onChangeData}
                value="NA">
              </Radio>
            </div>
          </FormGroup>
          <FormGroup
            style={{ display: "flex", alignItems: "center", marginLeft: "1rem" }}>
            <label
              style={{width: "38.5rem", whiteSpace: "normal"}}>
              {props.languageUX === "en" ? "4.5 Perineum care" : "4.5 การดูแลฝีเย็บ"}
            </label>
            <div
              style={{display: "flex", gap: "2rem", padding: "0rem 0rem 0rem 2rem"}}>
              
              <Radio
                checked={props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubFive === "Yes"}
                label="Yes"
                name="urinaryQuestion.urinaryQuestFourSubFive"
                onChange={props.onChangeData}
                value="Yes">
              </Radio>
              <Radio
                checked={props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubFive === "No"}
                label="No"
                name="urinaryQuestion.urinaryQuestFourSubFive"
                onChange={props.onChangeData}
                value="No">
              </Radio>
              <Radio
                checked={props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubFive === "NA"}
                label="NA"
                name="urinaryQuestion.urinaryQuestFourSubFive"
                onChange={props.onChangeData}
                value="NA">
              </Radio>
            </div>
          </FormGroup>
        </Form>
        <div
          style={{ display: "flex", justifyContent: "right", alignItems: "center" }}>
          
          <label
            style={{ display: "flex", alignItems: "center", margin: "0rem 2rem", fontWeight: "bold"  }}>
            {props.languageUX === "en" ? "Shift" : "กะ"}
          </label>
          <Radio
            checked={props.ReAssessmentSequence?.urinaryData?.saveShift === "Day"}
            label="Day"
            name="urinaryData.saveShift"
            onChange={props.onChangeData}
            style={{ display: "flex", alignItems: "center"  }}
            value="Day">
          </Radio>
          <Radio
            checked={props.ReAssessmentSequence?.urinaryData?.saveShift === "Night"}
            label="Night"
            name="urinaryData.saveShift"
            onChange={props.onChangeData}
            style={{ display: "flex", alignItems: "center", margin: "0rem 1rem"  }}
            value="Night">
          </Radio>
          <label
            style={{ display: "flex", alignItems: "center", margin: "0rem 2rem", fontWeight: "bold"  }}>
            {props.languageUX === "en" ? "Estimate Date" : "ประเมินวันที่"}
          </label>
          <DateTextBox
            onChange={props.onChangeDateUrinary}
            value={props.ReAssessmentSequence?.urinaryData?.saveData}>
          </DateTextBox>
          <label
            style={{ display: "flex", alignItems: "center", margin: "0rem 2rem", fontWeight: "bold"  }}>
            {props.languageUX === "en" ? "time" : "เวลา"}
          </label>
          <TimeFreeTextBox24
            autoFocus={false}
            onChange={props.onChangeTimeUrinary}
            value={props.ReAssessmentSequence?.urinaryData?.saveTime}>
          </TimeFreeTextBox24>
          <div
            style={{ margin: "0rem 0rem 0rem 2rem" }}>
            {props?.buttonSaveUrinary}
          </div>
        </div>
      </div>
    )
}


export default CardReAssessmentUrinaryUX

export const screenPropsDefault = {}

/* Date Time : Mon Aug 18 2025 09:30:52 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "style": {
          "type": "code",
          "value": "{position: \"relative\", padding: \"1rem\", marginTop: \"1rem\"}"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Form",
      "parent": 0,
      "props": {
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"right\", alignItems: \"center\" }"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "label",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "1. Hand Washing ล้างมือ 7 ขั้นตอน ตามหลักการ 5 Moment",
          "valueEN": "1. Hand Washing: Wash your hands in 7 steps according to the 5 Moment principle."
        },
        "style": {
          "type": "code",
          "value": "{width: \"40rem\", whiteSpace: \"normal\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "label",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": "2. Avoid unnecessary urinary catheters สวนปัสสาวะเมื่อมีความจำเป็นและมีข้อบ่งชี้เท่านั้น",
          "valueEN": "2. Avoid unnecessary urinary catheters. Urinary catheters should be used only when necessary and indicated."
        },
        "style": {
          "type": "code",
          "value": "{width: \"40rem\", whiteSpace: \"normal\"}"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "label",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "3. Review urinary catheter necessity daily พยาบาลสอบถามความจำเป็นการคาสายสวนปัสสาวะ กับแพทย์ทุกเช้า",
          "valueEN": "3. Review urinary catheter necessity daily. The nurse asks the doctor about the necessity of indwelling a urinary catheter every morning."
        },
        "style": {
          "type": "code",
          "value": "{width: \"40rem\", whiteSpace: \"normal\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "label",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "4. ดูแลรักษาสายสวนปัสสาวะตามคำแนะนำ",
          "valueEN": "4. Maintain urinary catheter based on recommended guideline"
        },
        "style": {
          "type": "code",
          "value": "{width: \"40rem\", whiteSpace: \"normal\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", gap: \"2rem\", padding: \"0rem 0rem 0rem 2rem\"}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", gap: \"2rem\", padding: \"0rem 0rem 0rem 2rem\"}"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", gap: \"2rem\", padding: \"0rem 0rem 0rem 2rem\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", gap: \"2rem\", padding: \"0rem 0rem 0rem 2rem\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "Radio",
      "parent": 16,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestOne === \"Yes\""
        },
        "label": {
          "type": "value",
          "value": "Yes"
        },
        "name": {
          "type": "value",
          "value": "urinaryQuestion.urinaryQuestOne"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "Yes"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "Radio",
      "parent": 16,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestOne === \"No\""
        },
        "label": {
          "type": "value",
          "value": "No"
        },
        "name": {
          "type": "value",
          "value": "urinaryQuestion.urinaryQuestOne"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "No"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "Radio",
      "parent": 16,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestOne === \"NA\""
        },
        "label": {
          "type": "value",
          "value": "NA"
        },
        "name": {
          "type": "value",
          "value": "urinaryQuestion.urinaryQuestOne"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "NA"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "Radio",
      "parent": 17,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestTwo === \"Yes\""
        },
        "label": {
          "type": "value",
          "value": "Yes"
        },
        "name": {
          "type": "value",
          "value": "urinaryQuestion.urinaryQuestTwo"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "Yes"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "Radio",
      "parent": 17,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestTwo === \"No\""
        },
        "label": {
          "type": "value",
          "value": "No"
        },
        "name": {
          "type": "value",
          "value": "urinaryQuestion.urinaryQuestTwo"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "No"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "Radio",
      "parent": 17,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestTwo === \"NA\""
        },
        "label": {
          "type": "value",
          "value": "NA"
        },
        "name": {
          "type": "value",
          "value": "urinaryQuestion.urinaryQuestTwo"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "NA"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "Radio",
      "parent": 18,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestThree === \"Yes\""
        },
        "label": {
          "type": "value",
          "value": "Yes"
        },
        "name": {
          "type": "value",
          "value": "urinaryQuestion.urinaryQuestThree"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "Yes"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "Radio",
      "parent": 18,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestThree === \"No\""
        },
        "label": {
          "type": "value",
          "value": "No"
        },
        "name": {
          "type": "value",
          "value": "urinaryQuestion.urinaryQuestThree"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "No"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "Radio",
      "parent": 18,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestThree === \"NA\""
        },
        "label": {
          "type": "value",
          "value": "NA"
        },
        "name": {
          "type": "value",
          "value": "urinaryQuestion.urinaryQuestThree"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "NA"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "Radio",
      "parent": 19,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFour === \"Yes\""
        },
        "label": {
          "type": "value",
          "value": "Yes"
        },
        "name": {
          "type": "value",
          "value": "urinaryQuestion.urinaryQuestFour"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "Yes"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "Radio",
      "parent": 19,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFour === \"No\""
        },
        "label": {
          "type": "value",
          "value": "No"
        },
        "name": {
          "type": "value",
          "value": "urinaryQuestion.urinaryQuestFour"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "No"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "Radio",
      "parent": 19,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFour === \"NA\""
        },
        "label": {
          "type": "value",
          "value": "NA"
        },
        "name": {
          "type": "value",
          "value": "urinaryQuestion.urinaryQuestFour"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "NA"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "Form",
      "parent": 0,
      "props": {
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "FormGroup",
      "parent": 32,
      "props": {
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", marginLeft: \"1rem\" }"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "FormGroup",
      "parent": 32,
      "props": {
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", marginLeft: \"1rem\" }"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "FormGroup",
      "parent": 32,
      "props": {
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", marginLeft: \"1rem\" }"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "FormGroup",
      "parent": 32,
      "props": {
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", marginLeft: \"1rem\" }"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "FormGroup",
      "parent": 32,
      "props": {
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", marginLeft: \"1rem\" }"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "label",
      "parent": 33,
      "props": {
        "children": {
          "type": "value",
          "value": "4.1 ระบบระบายน้ำแบบปิด",
          "valueEN": "4.1 Closed drainage system"
        },
        "style": {
          "type": "code",
          "value": "{width: \"38.5rem\", whiteSpace: \"normal\"}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "label",
      "parent": 34,
      "props": {
        "children": {
          "type": "value",
          "value": "4.2 สายสวนปัสสาวะแบบติดแน่น",
          "valueEN": "4.2 Fixed catheter"
        },
        "style": {
          "type": "code",
          "value": "{width: \"38.5rem\", whiteSpace: \"normal\"}"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "label",
      "parent": 35,
      "props": {
        "children": {
          "type": "value",
          "value": "4.3 ถุงปัสสาวะห้อยอยู่ใต้กระเพาะปัสสาวะ",
          "valueEN": "4.3 Urine bag hang below bladder"
        },
        "style": {
          "type": "code",
          "value": "{width: \"38.5rem\", whiteSpace: \"normal\"}"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "label",
      "parent": 36,
      "props": {
        "children": {
          "type": "value",
          "value": "4.4 เทคนิคปลอดเชื้อ",
          "valueEN": "4.4 Aseptic technique"
        },
        "style": {
          "type": "code",
          "value": "{width: \"38.5rem\", whiteSpace: \"normal\"}"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "label",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": "4.5 การดูแลฝีเย็บ",
          "valueEN": "4.5 Perineum care"
        },
        "style": {
          "type": "code",
          "value": "{width: \"38.5rem\", whiteSpace: \"normal\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "div",
      "parent": 33,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", gap: \"2rem\", padding: \"0rem 0rem 0rem 2rem\"}"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "div",
      "parent": 34,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", gap: \"2rem\", padding: \"0rem 0rem 0rem 2rem\"}"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "div",
      "parent": 35,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", gap: \"2rem\", padding: \"0rem 0rem 0rem 2rem\"}"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "div",
      "parent": 36,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", gap: \"2rem\", padding: \"0rem 0rem 0rem 2rem\"}"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", gap: \"2rem\", padding: \"0rem 0rem 0rem 2rem\"}"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "Radio",
      "parent": 43,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubOne === \"Yes\""
        },
        "label": {
          "type": "value",
          "value": "Yes"
        },
        "name": {
          "type": "value",
          "value": "urinaryQuestion.urinaryQuestFourSubOne"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "Yes"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "Radio",
      "parent": 43,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubOne === \"No\""
        },
        "label": {
          "type": "value",
          "value": "No"
        },
        "name": {
          "type": "value",
          "value": "urinaryQuestion.urinaryQuestFourSubOne"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "No"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "Radio",
      "parent": 43,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubOne === \"NA\""
        },
        "label": {
          "type": "value",
          "value": "NA"
        },
        "name": {
          "type": "value",
          "value": "urinaryQuestion.urinaryQuestFourSubOne"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "NA"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "Radio",
      "parent": 44,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubTwo === \"Yes\""
        },
        "label": {
          "type": "value",
          "value": "Yes"
        },
        "name": {
          "type": "value",
          "value": "urinaryQuestion.urinaryQuestFourSubTwo"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "Yes"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "Radio",
      "parent": 44,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubTwo === \"No\""
        },
        "label": {
          "type": "value",
          "value": "No"
        },
        "name": {
          "type": "value",
          "value": "urinaryQuestion.urinaryQuestFourSubTwo"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "No"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "Radio",
      "parent": 44,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubTwo === \"NA\""
        },
        "label": {
          "type": "value",
          "value": "NA"
        },
        "name": {
          "type": "value",
          "value": "urinaryQuestion.urinaryQuestFourSubTwo"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "NA"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "Radio",
      "parent": 45,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubThree === \"Yes\""
        },
        "label": {
          "type": "value",
          "value": "Yes"
        },
        "name": {
          "type": "value",
          "value": "urinaryQuestion.urinaryQuestFourSubThree"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "Yes"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "Radio",
      "parent": 45,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubThree === \"No\""
        },
        "label": {
          "type": "value",
          "value": "No"
        },
        "name": {
          "type": "value",
          "value": "urinaryQuestion.urinaryQuestFourSubThree"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "No"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 56,
      "name": "Radio",
      "parent": 45,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubThree === \"NA\""
        },
        "label": {
          "type": "value",
          "value": "NA"
        },
        "name": {
          "type": "value",
          "value": "urinaryQuestion.urinaryQuestFourSubThree"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "NA"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "Radio",
      "parent": 46,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubFour === \"Yes\""
        },
        "label": {
          "type": "value",
          "value": "Yes"
        },
        "name": {
          "type": "value",
          "value": "urinaryQuestion.urinaryQuestFourSubFour"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "Yes"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "Radio",
      "parent": 46,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubFour === \"No\""
        },
        "label": {
          "type": "value",
          "value": "No"
        },
        "name": {
          "type": "value",
          "value": "urinaryQuestion.urinaryQuestFourSubFour"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "No"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "Radio",
      "parent": 46,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubFour === \"NA\""
        },
        "label": {
          "type": "value",
          "value": "NA"
        },
        "name": {
          "type": "value",
          "value": "urinaryQuestion.urinaryQuestFourSubFour"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "NA"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "Radio",
      "parent": 47,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubFive === \"Yes\""
        },
        "label": {
          "type": "value",
          "value": "Yes"
        },
        "name": {
          "type": "value",
          "value": "urinaryQuestion.urinaryQuestFourSubFive"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "Yes"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 61,
      "name": "Radio",
      "parent": 47,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubFive === \"No\""
        },
        "label": {
          "type": "value",
          "value": "No"
        },
        "name": {
          "type": "value",
          "value": "urinaryQuestion.urinaryQuestFourSubFive"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "No"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "Radio",
      "parent": 47,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryQuestion?.urinaryQuestFourSubFive === \"NA\""
        },
        "label": {
          "type": "value",
          "value": "NA"
        },
        "name": {
          "type": "value",
          "value": "urinaryQuestion.urinaryQuestFourSubFive"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "NA"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "label",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": "กะ",
          "valueEN": "Shift"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", margin: \"0rem 2rem\", fontWeight: \"bold\"  }"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "Radio",
      "parent": 11,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryData?.saveShift === \"Day\""
        },
        "label": {
          "type": "value",
          "value": "Day"
        },
        "name": {
          "type": "value",
          "value": "urinaryData.saveShift"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\"  }"
        },
        "value": {
          "type": "value",
          "value": "Day"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "Radio",
      "parent": 11,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryData?.saveShift === \"Night\""
        },
        "label": {
          "type": "value",
          "value": "Night"
        },
        "name": {
          "type": "value",
          "value": "urinaryData.saveShift"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", margin: \"0rem 1rem\"  }"
        },
        "value": {
          "type": "value",
          "value": "Night"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "label",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเมินวันที่",
          "valueEN": "Estimate Date"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", margin: \"0rem 2rem\", fontWeight: \"bold\"  }"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 67,
      "name": "DateTextBox",
      "parent": 11,
      "props": {
        "onChange": {
          "type": "code",
          "value": "props.onChangeDateUrinary"
        },
        "value": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryData?.saveData"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "label",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลา",
          "valueEN": "time"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", margin: \"0rem 2rem\", fontWeight: \"bold\"  }"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 69,
      "name": "TimeFreeTextBox24",
      "parent": 11,
      "props": {
        "autoFocus": {
          "type": "code",
          "value": "false"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeTimeUrinary"
        },
        "value": {
          "type": "code",
          "value": "props.ReAssessmentSequence?.urinaryData?.saveTime"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "code",
          "value": "props?.buttonSaveUrinary"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0rem 0rem 0rem 2rem\" }"
        }
      },
      "seq": 70,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardReAssessmentUrinaryUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
